import MessagesService from "../services/messages";

export const REQUEST_FAILED = "REQUEST_FAILED";
export const REQUEST_GET_USER_INBOX = "REQUEST_GET_USER_INBOX";
export const REFRESH_USER_INBOX = "REFRESH_USER_INBOX";
export const REQUEST_USER_CONVERSATION = "REQUEST_USER_CONVERSATION";
export const REFRESH_USER_CONVERSATION = "REFRESH_USER_CONVERSATION";
export const REQUEST_SET_MESSAGE_TO_ARCHIVED =
  "REQUEST_SET_MESSAGE_TO_ARCHIVED";
export const REQUEST_SET_MESSAGE_TO_VIEWED = "REQUEST_SET_MESSAGE_TO_VIEWED";
export const SET_MESSAGE_ARCHIVED = "SET_MESSAGE_ARCHIVED";
export const SET_MESSAGE_VIEWED = "SET_MESSAGE_VIEWED";
export const DECREMENT_INBOX_COUNT = "DECREMENT_INBOX_COUNT";

const decrementInboxUnreadCount = (userId) => ({
  type: DECREMENT_INBOX_COUNT,
  userId,
});
const requestFailed = (error) => ({
  type: REQUEST_FAILED,
  error,
});

export const requestGetUserInbox = (userId) => ({
  type: REQUEST_GET_USER_INBOX,
  userId,
});

export const refreshUserInbox = (inbox) => ({
  type: REFRESH_USER_INBOX,
  inbox,
});

const requestUserConversation = (userId, userId2) => ({
  type: REQUEST_USER_CONVERSATION,
  userId,
  userId2,
});

const refreshUserConversation = (
  selectedMessageContactId,
  selectedMessageContactName,
  messageList
) => ({
  type: REFRESH_USER_CONVERSATION,
  selectedMessageContactId,
  selectedMessageContactName,
  messageList,
});

const requestSetMessageToViewed = (messageId) => ({
  type: REQUEST_SET_MESSAGE_TO_VIEWED,
  messageId,
});

const setStateMessageToViewed = (messageId) => ({
  type: SET_MESSAGE_VIEWED,
  messageId,
});

const requestSetMessageToArchived = (messageId) => ({
  type: REQUEST_SET_MESSAGE_TO_ARCHIVED,
  messageId,
});

const setStateMessageToArchived = (messageId) => ({
  type: SET_MESSAGE_ARCHIVED,
  messageId,
});

export const decrementInboxUnreadCountForUser = (userId) => async (
  dispatch
) => {
  dispatch(decrementInboxUnreadCount(userId));
};

export const getUserInbox = (userId) => async (dispatch) => {
  dispatch(requestGetUserInbox(userId));
  try {
    const result = await MessagesService().getUserInbox(userId);
    if (result && result.inboxList) {
      dispatch(refreshUserInbox(result.inboxList));
    } else {
      dispatch(requestFailed("Unable to get user notifications!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const getUserConversation = (userId, userId2, name) => async (
  dispatch
) => {
  dispatch(requestUserConversation(userId));
  try {
    const result = await MessagesService().getMessagesBetweenUsers(
      userId,
      userId2
    );
    if (result && result.messageList) {
      dispatch(refreshUserConversation(userId2, name, result.messageList));
    } else {
      dispatch(requestFailed("Unable to get conversation list!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const setMessageToViewed = (messageId) => async (dispatch) => {
  dispatch(requestSetMessageToViewed(messageId));
  try {
    const result = await MessagesService().setMessageToViewed(messageId);
    if (result && result.response === "ok") {
      dispatch(setStateMessageToViewed(messageId));
    } else {
      dispatch(requestFailed("Unable to upate message to viewed!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};

export const setMessageToArchived = (messageId) => async (dispatch) => {
  dispatch(requestSetMessageToArchived(messageId));
  try {
    const result = await MessagesService().setMessageToArchived(messageId);
    if (result && result.response === "ok") {
      dispatch(setStateMessageToArchived(messageId));
    } else {
      dispatch(requestFailed("Unable to upate message to archived!"));
    }
  } catch (error) {
    dispatch(requestFailed("Internal error!"));
  }
};



// WEBPACK FOOTER //
// ./src/actions/messages.js